import { fade, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    searchBarContainer: ({ modo, fixo }: any) => ({
        position: 'relative',
        width: '100%',
        borderRadius: modo === 'dinamic' ? 0 : theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.background.paper, 0.60),
        border: modo !== 'dinamic' ? `1px solid ${theme.palette.divider}` : '',
        minHeight: 48,
        display: 'flex',
        alignItems: 'center',
        transition: theme.transitions.create(['box-shadow', 'border-color', 'background-color'], {
            duration: theme.transitions.duration.shortest,
        }),
        boxShadow: theme.palette.type === 'light' ? theme.shadows[1] : 'none',
        '&:hover': {
            boxShadow: modo !== 'dinamic' ? theme.shadows[2] : 'none',
            borderColor: theme.palette.action.hover,
        },
        '&:focus-within': {
            borderColor: modo !== 'dinamic' ? theme.palette.primary.main : '',
            boxShadow: modo !== 'dinamic' ? `${theme.palette.primary.main}33 0px 0px 0px 3px` : 'none',
        },
        [theme.breakpoints.down('sm')]: {
            minHeight: 42,
        },
    }),
    searchBar: ({ modo }: any) => ({
        display: 'flex',
        borderRadius: modo === 'dinamic' ? 0 : theme.shape.borderRadius,
        flex: 1,
    }),
    inputRoot: {
        color: theme.palette.text.primary,
        padding: '0 16px',
    },
    input: ({ modo }: any) => ({
        padding: modo === 'static' ? '12px' : theme.spacing(2, 1),
        transition: theme.transitions.create('width'),
        width: '100%',
        fontSize: '0.95rem',
        '&::placeholder': {
            color: theme.palette.text.secondary,
            opacity: 1,
        },
    }),
    searchIcon: {
        color: theme.palette.primary.main,
        fontSize: 22,
        marginRight: 4,
    },
    cancelSearchIcon: ({ modo }: any) => ({
        color: theme.palette.text.secondary,
        position: 'absolute',
        right: 8,
        top: '50%',
        transform: 'translateY(-50%)',
        margin: 'auto',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    }),
}));